export default __webpack_public_path__ + "static/media/scroll-arrow.4529359f.svg";